var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('a-tabs',{attrs:{"tab-position":"right"}},[_c('a-tab-pane',{key:"AUM",attrs:{"tab":"AUM"}},[_c('AUMEdit')],1),_c('a-tab-pane',{key:"Weight",attrs:{"tab":"Weight"}},[_c('WeightEdit')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }